"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("../style"));

var _select = _interopRequireDefault(require("../style/select"));

var _createStyled = require("../../../utils/createStyled");

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _prepareOptionContent = _interopRequireDefault(require("../utils/prepareOptionContent"));

var _border = _interopRequireDefault(require("../views/border.c"));

var _label = _interopRequireDefault(require("../views/label.c"));

function template() {
  var styles = this.compileStyled(_style["default"]),
      selectStyles = this.compileStyled(_select["default"]),
      _this$props = this.props,
      label = _this$props.label,
      placeholder = _this$props.placeholder,
      emptyListPlaceholder = _this$props.emptyListPlaceholder,
      attribute = _this$props.attribute,
      className = _this$props.className,
      disabled = _this$props.disabled,
      readOnly = _this$props.readOnly,
      list = this.state.list,
      selected = this._getSelected();

  var options = [],
      value;

  if (selected) {
    value = (0, _prepareOptionContent["default"])(selected, {
      isSelected: false,
      isSelectItem: true
    });
  }

  if (list && list.length) {
    options = list.map(function (item) {
      var isSelected = selected && item.id === selected.id,
          _prepareOption = (0, _prepareOptionContent["default"])(item, {
        isSelected: isSelected,
        isSelectItem: false
      }),
          title = _prepareOption.title;

      return _react["default"].createElement("option", {
        value: title,
        key: title,
        "data-qa-node": attribute + '-option',
        "data-qa-value": title,
        id: item.id
      }, title);
    });
  }

  var notSelected = list && list.length ? _l10n["default"].translate(placeholder) : _l10n["default"].translate(emptyListPlaceholder);
  options.unshift(_react["default"].createElement("option", {
    value: "__dropDownDefaultNotSelected",
    key: notSelected,
    disabled: true
  }, notSelected));
  return _react["default"].createElement(_createStyled.Styled.Div, {
    className: className,
    styles: styles.root,
    ref: this._rootRef,
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper
  }, _react["default"].createElement(_label["default"], (0, _extends2["default"])({}, this.props, {
    styles: styles,
    label: label
  })), _react["default"].createElement(_createStyled.Styled.Div, {
    styles: selectStyles.field
  }, _react["default"].createElement(_createStyled.Styled.Select, {
    styles: selectStyles.nativeSelect,
    value: value ? value.title : '__dropDownDefaultNotSelected',
    disabled: disabled,
    readOnly: readOnly,
    onChange: this._handleNativeSelectChange
  }, options)), _react["default"].createElement(_border["default"], (0, _extends2["default"])({}, this.props, {
    styles: styles
  }))));
}